import AuthenticationService from "@/services/AuthenticationService.js";
import httpStatusDefinitions from "@/data/httpStatusDefinitions";
import router from "@/router.js";
import EventBus from "@/utilities/eventBus.js";

export default function(error) {

  // if the user is somehow getting an endpoint error and their token is expired, send to /session-expired
  // we're already checking this on the interceptor in authAxios.js, but we'll check here as well just in case
  if (AuthenticationService.secondsUntilAccessTokenExpires() <= 0) { router.push("/session-expired"); return false; }

  if (error.message === "Network Error") error = { response: { data: { message: "Network Error" }, request: { responseURL: error.config.url } } };

  // if this is an error of the new type that defines "globalErrors", let's create a better message for the toast by concatenating those messages
  if (error.response?.data?.errors?.globalErrors?.length) {
    error.response.data.message = error.response.data.errors.globalErrors.map(gE => gE.defaultMessage).join(" ");
  }

  if (document.querySelector("#app[data-v-app]")) {
    // handle errors within the vue app with a toast message
    const summary = `Error` + ([ "http://localhost:8081", "https://app.whqdev.dev", "https://app.whqtest.com" ].includes(import.meta.env.VITE_URL) && error.response?.status ? ` <small>(${error.response.status}: ${httpStatusDefinitions.find(eD => eD.code === error.response.status).reason})</small>` : "");
    const detail = `<p class="mt-2 mb-0">${error.response?.data?.message ? error.response.data.message : "Something went wrong with this page."}</p>${["localhost","whqdev","whqtest"].includes(import.meta.env.VITE_URL) ? ('<small class="block mt-2 text-truncate">' + new URL(error.response.request.responseURL).pathname + '</small>') : ''}`;
    EventBus.emit('add-toast', { severity: 'error', args: [detail, summary] })
  } else {
    
    if (error.response) {
      // handle errors before the vue app mounts by replacing #app with an error message
      // throw new error at the end because we want everything to stop (so errors don't stack)
      let errorStyles = document.createElement("style");
      errorStyles.innerHTML = `
        * { box-sizing: border-box; }
        .error-dialog { position:absolute; display:block; text-align:center; background-color:#ffffff; color:#212121; border-radius:4px; padding:1.25rem; text-align:left; left:1rem; right:1rem; top:50%; transform:translateY(-50%); line-height:1.5; box-shadow:0 11px 15px -7px rgb(0 0 0 / 20%), 0 24px 38px 3px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%); max-height:calc(100% - 2rem); overflow:auto; }
        @media(min-width: 414px) { .error-dialog { left:50%; right:auto; width:375px; transform:translate(-50%, -50%); } }
        .error-dialog h2 { font-weight:500; font-size:1.25rem; margin:0; }
        .error-dialog p { font-family:"Gilroy", sans-serif; }
        .error-dialog p.path { margin-top:0; margin-bottom:1rem; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
        .error-dialog p a { color:#1da3d9; text-decoration:none; }
        .error-dialog .error-button { color:#ffffff; background:#1da3d9; display:inline-block; padding:0.5rem 1.5rem; border-radius:99px; }
      `;
      let errorDiv = document.createElement("div");
      errorDiv.classList.add("error-dialog");
      errorDiv.innerHTML += `
        <h2>Error` + (error.response?.status && error.response?.status !== 200 && error.response?.status !== 201 ? ` <small>(${error.response.status}: ${httpStatusDefinitions.find(eD => eD.code === error.response.status).reason})</small>` : "") + `</h2>
        <p class="path"><small>${error.response ? new URL(error.response.request.responseURL).pathname : ""}</small></p>
        <p>${error.response?.data.message ? error.response.data.message : "Something went wrong with this page."}</p>
        <p><a href="mailto:itsupport@warehousequote.com?subject=WarehouseQuote.com%20Web%20Application%20User%20Login%20Issue">Contact us</a> if you need help.</p>
        <p style="text-align:right;margin-bottom:0;"><a href="/" class="error-button">Try&nbsp;Again</a></p>
      `;
      document.head.appendChild(errorStyles);
      document.body.appendChild(errorDiv);
      document.getElementById("app") ?? document.getElementById("app").remove();
    }
    window.history.replaceState({}, document.title, "/");
    AuthenticationService.removeTokensFromLocalStorage();
    throw new Error(error.response?.data.message ? error.response.data.message : "Something went wrong with this page.");

  }
  
  return false;

};